import * as React from "react";
import * as ReactDOM from "react-dom";
import {
    StatisticsPieChartClassesByYear,
    StatisticsBarChartVerticalMemberQuantities,
    StatisticsBarChartHorizontalMemberQuantitiesByDivision
} from './charts';

declare global {
    interface Window {
        StatisticsPieChartClassesByYear: any;
        StatisticsBarChartVerticalMemberQuantities: any;
        StatisticsBarChartHorizontalMemberQuantitiesByDivision: any;
    }
}


window.StatisticsPieChartClassesByYear = function (elementId: string, data: any, width: number = null, height: number = null) {
    ReactDOM.render(<StatisticsPieChartClassesByYear data={data} width={width} height={height} />, document.getElementById(elementId));
}

window.StatisticsBarChartVerticalMemberQuantities = function (elementId: string, data: any, width: number = null, height: number = null) {
    ReactDOM.render(<StatisticsBarChartVerticalMemberQuantities data={data} width={width} height={height} />, document.getElementById(elementId));
}

window.StatisticsBarChartHorizontalMemberQuantitiesByDivision = function (elementId: string, data: any, width: number = null, height: number = null) {
    ReactDOM.render(<StatisticsBarChartHorizontalMemberQuantitiesByDivision data={data} width={width} height={height} />, document.getElementById(elementId));
}
